'use strict';

import logger from './logger.js';

export default {
	pushToDataLayer: (obj) => {
		if (obj) {
			if (typeof window.bauerDataLayer !== 'undefined') {
				logger.info('GTM data layer push', obj);
				window.bauerDataLayer.push(obj);
			} else {
				logger.warn('GTM data layer not defined');
			}
		}
	},

	getMakeAndModelName: () => {
		if (!window.bauerDataLayer || window.bauerDataLayer.length === 0) {
			logger.warn('GTM data layer not defined');
			return null;
		}

		const modelName = window.bauerDataLayer[0].vehicle?.modelName;

		if (!modelName || modelName.length === 0) {
			return null;
		}

		const makeName = window.bauerDataLayer[0].vehicle?.makeName;

		if (modelName === 'NotSet') {
			const rangeName = window.bauerDataLayer[0].vehicle?.rangeName;
			return `${makeName} ${rangeName}`;
		}

		return `${makeName} ${modelName}`;
	}
};
